export default {
  data () {
    return {
      insertPaths: []
    }
  },
  computed: {
    showingPolygon () {
      return this.insertPaths.length === 0
    }
  },
  methods: {
    showPolygon () {
      this.insertPaths = this.range.paths
    },
    finishShowPolygon () {
      this.insertPaths = []
    }
  }
}
